import { FC } from 'react';

import { UnstyledLink } from '@rikstv/play-common/src/router/Link';
import { H2 } from '@rikstv/shared-components';

import { ContentStackMetadata } from '../../contentStack.types';
import { useSeriesParentLink } from '../../hooks/seasonHooks';

import styles from '../MediaMetadata.module.css';

export const ParentSeriesLink: FC<{ media: ContentStackMetadata }> = ({ media }) => {
  const { seriesLink, seriesName } = useSeriesParentLink(media);
  if (!seriesLink) {
    return null;
  }
  return (
    <div className={styles.seriesBackLink}>
      <UnstyledLink to={seriesLink}>
        <H2>
          ← <span className="sr-only">Tilbake til serien:</span> {seriesName}
        </H2>
      </UnstyledLink>
    </div>
  );
};
